import {Component} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {MatDialog} from "@angular/material/dialog";
import {LogoutDialogComponent} from "./logout-dialog/logout-dialog.component";
import {TranslatePipe} from "@ngx-translate/core";

@Component({
  selector: 'home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
  imports: [TranslatePipe]
})
export class HomeComponent {

  constructor(
      private readonly _activatedRoute: ActivatedRoute,
      private readonly _matDialog: MatDialog,
  ) {
    _activatedRoute.data.subscribe(data => {
      if (data["isLogout"]) {
        this._matDialog.open(LogoutDialogComponent, {disableClose: true})
      }
    })
  }
}
